import { Component, ViewChild, AfterViewInit } from '@angular/core';
import {UsersService} from '../../../services/users.service';
import { InstalacionesService} from "../../../services/instalaciones.service";
import { TranslateService } from '@ngx-translate/core';
import { Router} from '@angular/router';
import {environment} from '../../../../environments/environment'
import { ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed  #cabecera>
        
      
        <ngx-header class="header" >
        </ngx-header>
        <ng-content select="nb-menu"></ng-content>
      </nb-layout-header>

      <nb-layout-column>
      <div class="barra-roja">
       
         <button class="btn-menu-user" (click)="toggleMenu()"><nb-icon icon="person-outline" class="usuario" *ngIf="estoyLogueado"></nb-icon></button>
         <div class="menu-container" id="menu" *ngIf="cogerRolAdmin && estoyLogueado">
            <div>
              <button (click)="logout()">{{this.menu_cerrar_sesion}}</button>
            </div>
            <div>
              <button (click)="admin_users()">{{this.menu_admin_users}}</button>
            </div>
            <div>
              <button (click)="contactar()">{{this.menu_contacto}}</button>
            </div>
          </div>

          <div class="menu-container-user" id="menu" *ngIf="cogerRolUsuario && estoyLogueado">
            <div>
              <button (click)="logout()">{{this.menu_cerrar_sesion}}</button>
            </div>
            <div>
              <button (click)="contactar()">{{this.menu_contacto}}</button>
            </div>
          </div>

        <button class="btn-salir" (click)="logout()"><nb-icon icon="log-out-outline" class="salir" *ngIf="estoyLogueado"></nb-icon></button>
      
        
        <div class="col-md-5 selectIdioma" *ngIf="!estoyLogueado">
        <div (click)="toggleDesplegable()" id="marco">
        <span id="customSelect" class="specialSelect">{{ activeLang.toUpperCase() || 'ES' }} <i class="fas fa-chevron-down"></i></span>
        </div>

        <div id="desplegable">
        <span (click)="selected('es')" class="specialOption" [ngClass]="{'active': activeLang == 'es'}">ES</span>
        <span (click)="selected('en')" class="specialOption" [ngClass]="{'active': activeLang == 'en'}">EN</span>
        <span (click)="selected('fr')" class="specialOption" [ngClass]="{'active': activeLang == 'fr'}">FR</span>
        <span (click)="selected('it')" class="specialOption"  [ngClass]="{'active': activeLang == 'it'}">IT</span>
        </div>
        </div>
       
      </div>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer>
        </ngx-footer>
        <a class="logo-footer" href="https://emac.es/" target="_blank" hypertag="'Emac'"><img height= 210px; src="../../../../assets/images/logos/logo_emac_grupo.png"></a>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements AfterViewInit {

  cogerLogin = localStorage.getItem("login");

  cogerUsuario: string;
  cogerRolAdmin: boolean;
  cogerRolUsuario: boolean;
  estoyLogueado: boolean;

  menu_cerrar_sesion:string;
  menu_admin_users:string;
  menu_contacto:string;
  menuVisible = false;
  
  usuario: string;
  token: string;

  @ViewChild('cabecera', { static: true }) cabecera;

  activeLang: string;

  constructor( private usersService: UsersService, private InstalacionesService:InstalacionesService, private translate: TranslateService,  private router: Router,private el: ElementRef, private renderer: Renderer2){


    if(localStorage.getItem("idioma") == null || localStorage.getItem("idioma") == undefined){

      this.activeLang = 'es'

    }else{

      this.activeLang = localStorage.getItem("idioma")

    }

        this.translate.setDefaultLang(this.activeLang);
  }

  ngOnInit(){

  if( localStorage.getItem("logueado") == "true"){

    this.estoyLogueado = true;

  }else{

    this.estoyLogueado = false;
  }

  console.log(this.activeLang)

  if(this.activeLang == "es"){

    this.menu_cerrar_sesion = "CERRAR SESIÓN"
    this.menu_admin_users = "ADMINISTRAR USUARIOS"
    this.menu_contacto = "CONTACTO"

  }else if(this.activeLang == "en"){

    this.menu_cerrar_sesion = "SIGN OFF"
    this.menu_admin_users = "MANAGE USERS"
    this.menu_contacto = "CONTACT"

  }else if(this.activeLang == "it"){

    this.menu_cerrar_sesion = "USCIRE"
    this.menu_admin_users = "GESTIRE GLI UTENTI"
    this.menu_contacto = "CONTATTO"

  }else if(this.activeLang == "fr"){

    this.menu_cerrar_sesion = "SORTIR"
    this.menu_admin_users = "GESTION DES UTILISATEURS"
    this.menu_contacto = "CONTACT"

  }

  }

  ngAfterViewInit() {

    this.toggleMenu();
    
  }

  logout(){
    this.usersService.logout();
  }

  info(){
    this.usersService.info();
  }

  onChange(evento){

    this.InstalacionesService.cambiarLenguaje(evento)
    


  }

  selected(option: string){
    console.log(option)
    let desplegable = document.getElementById("desplegable");
    let custom = document.getElementById("customSelect");
    if(desplegable.style.display === "none"){
    desplegable.style.display = "block";
   
    }else{
    desplegable.style.display = "none";
    }
    
    if(option !== undefined){
    custom.innerText = option;
    
    }

    this.InstalacionesService.cambiarLenguaje(option)
    }

    toggleDesplegable() {
      let desplegable = document.getElementById("desplegable");
      
      if (desplegable.style.display === "none") {
          desplegable.style.display = "block";
        
      } else {
          desplegable.style.display = "none";
      }
  }

  toggleMenu() {

    if(localStorage.getItem("rol") == "1"){

      this.cogerRolAdmin = true;
      this.cogerRolUsuario = false;
  
     }else if(localStorage.getItem("rol") == "2" || localStorage.getItem("rol") == "3"){
      this.cogerRolAdmin = false;
      this.cogerRolUsuario = true;
     }

     var menu = document.getElementById('menu');
     menu.style.display = (menu.style.display == 'block') ? 'none' : 'block';
    
  }

  admin_users(){

    this.usuario = localStorage.getItem("usuario");
    this.token = localStorage.getItem("token")

    //this.InstalacionesService.verificarTokenUser(this.token, this.usuario).subscribe(respuestaToken =>{

      /*if(!respuestaToken.status){

        localStorage.removeItem('usuario');
        localStorage.removeItem('nombre_usuario');
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('selectedEdificio');
        localStorage.removeItem('rol');
        localStorage.setItem('logueado', 'false')
        this.router.navigate([environment.servidor+'/pages/login']);
        window.location.reload();
      }else{*/
        this.router.navigate(['/pages/administrar-usuarios']);
      //}
   // })
     
  }

  contactar(){
    this.usuario = localStorage.getItem("usuario");
    this.token = localStorage.getItem("token")

    //this.InstalacionesService.verificarTokenUser(this.token, this.usuario).subscribe(respuestaToken =>{

      /*if(!respuestaToken.status){

        localStorage.removeItem('usuario');
        localStorage.removeItem('nombre_usuario');
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('selectedEdificio');
        localStorage.removeItem('rol');
        localStorage.setItem('logueado', 'false')
        this.router.navigate([environment.servidor+'/pages/login']);
        window.location.reload();
      }else{*/
        this.router.navigate(['/pages/contacto']);
     // }
   // })
 }
}
